import * as React from 'react';

import {StatusPage} from 'shells/import2/status-page';

import type {CrmOptionType} from 'nutshell-graphql-types';
import type {Import2StatusFragment} from 'nutshell-graphql-types';

import {useApproveImport2FullMigration, useRequestImport2Sponsorship} from './graphql/hooks';
import {getLinkToImports} from './helpers';

type Props = {
    importStatus: Import2StatusFragment;
    refetchImportStatus: () => Promise<any>;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
    onInitiateImport: (crmType: CrmOptionType) => void;
};

export function ImportStatus(props: Props) {
    const {startPolling, stopPolling} = props;

    const approveImport2FullMigration = useApproveImport2FullMigration();
    const requestImport2Sponsorship = useRequestImport2Sponsorship();

    React.useEffect(() => {
        startPolling(30000); // 30 seconds

        return () => {
            stopPolling();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isSupportLogin = NutClientConfig.isSupportLogin;

    return (
        <StatusPage
            importStatus={props.importStatus}
            isSupportLogin={isSupportLogin}
            requestImport2Sponsorship={requestImport2Sponsorship}
            approveImport2FullMigration={approveImport2FullMigration}
            refetchImportStatus={props.refetchImportStatus}
            getLinkToImports={getLinkToImports}
            onInitiateImport={props.onInitiateImport}
        />
    );
}
